// NEON — dark glow cards. Fixed-dark template (darkDefault): the wrapper is a
// deep-navy panel and each card is edged in the accent color with a soft
// accent glow. Uses its own literal dark palette (termBg/termInk/termSub per
// the design reference) + ctx.v.accent; the glow shadow is rebuilt from
// ctx.tokens.accent on every render.
const BG = '#0b1220'; // termBg
const CARD_BG = '#101a2e'; // neonCardBg
const INK = '#e6f0ff'; // termInk
const SUB = '#9fb3cc'; // termSub
function itemHtml(ctx, it) {
    return `<div class="fq-acc"${ctx.reveal(it.idx)}>
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span>${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const neon = {
    id: 'neon',
    name: 'Neon',
    tag: 'Glow cards',
    styleTag: 'Dark vibrant',
    description: 'Dark cards edged in your accent color with a soft glow. Built for products that launch at night \u2014 games, crypto, creator tools.',
    layout: 'cards',
    defaultAccent: '#7c3aed',
    darkDefault: true,
    catSupport: 'none',
    features: ['accordion', 'reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const glow = ctx.rgba(ctx.tokens.accent, 0.35);
        const css = `
.FQM .fq-wrap{max-width:720px;margin:0 auto;padding:40px 34px 44px;border-radius:${ctx.v.radiusWrap};background:${BG}}
.FQM .fq-head{text-align:center;margin-bottom:28px}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:32px;font-weight:700;line-height:1.12;letter-spacing:-0.015em;color:#ffffff}
.FQM .fq-sub{margin:0;font-size:15px;line-height:1.6;color:${SUB}}
.FQM .fq-list{display:flex;flex-direction:column;gap:12px}
.FQM .fq-acc{background:${CARD_BG};border:1px solid ${ctx.v.accent};border-radius:${ctx.v.radiusCard};box-shadow:0 0 22px ${glow}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:17px 20px;font-size:16px;font-weight:500;line-height:1.4;color:${INK}}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 20px 18px;font-size:14.5px;line-height:1.65;color:${SUB}}
`;
        return { html, css };
    },
};
export default neon;
